/* @flow */
import Collection from 'lib/Collection';
import GroupClusterItem from 'entities/GroupClusterItem';

export default class GroupClusterItems extends Collection {
  initialize() {
    this.model = GroupClusterItem;
  }
}



// WEBPACK FOOTER //
// ./src/collections/GroupClusterItems.js